module.exports = __webpack_public_path__ + "img/montalcino.1d8b4cfa.jpg";